// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fv-d","colBig":"styles_colBig__2cNYc","colSmall":"styles_colSmall__3wrvW","shopifyNameWrapper":"styles_shopifyNameWrapper__2_Mj9"};